module.exports = __webpack_public_path__ + "images/7dc80997194cca5fec61adc514c11d9e.svg";